/**
 * useOrganization hook
 *
 * Provides the current user's organization membership from AuthContext.
 * Returns null if the user is not an organization member.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/lib/auth";
import type { OrgMembership } from "@/lib/organizations/types";
export function useOrganization() {
  const $ = _c(4);
  const {
    organization,
    isLoading
  } = useAuth();
  const t0 = organization ?? null;
  const t1 = !!organization;
  let t2;
  if ($[0] !== isLoading || $[1] !== t0 || $[2] !== t1) {
    t2 = {
      organization: t0,
      isOrgUser: t1,
      isLoading
    };
    $[0] = isLoading;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}